import React from 'react';
import { CrossSellPromo } from '@stitch-fix/mode-react';
import { trackOnboardingCtaClick } from './StyleQuizAd.tracking';
import { useProductDetailsPageContext } from '../ProductDetailsPage/ProductDetailsPageContext/ProductDetailsPageContext';

/**
 * Displays an ad containing a business-line-dependent video and a CTA
 * prompting the user to take their style quiz
 */

const PROMO_IMAGE = {
  altText: 'Promotion',
  baseUrl: 'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
  mediaPath:
    '/v1721172154/landing-pages/pages/US/BRND-FY24-WEB-Rebrand%20Client%20Experience%20Audit-1207669956273077/Ungated%20PDP%20Promo/Ungated_PDP_Promo_GN.png',
};
const CTA_TEXT = 'Take your style quiz';

const StyleQuizAd = () => {
  const [state] = useProductDetailsPageContext();
  const clientBusinessLine = state.clientBusinessLine;
  const itemBusinessLine = state.productBusinessLine;
  const selectedSkuId = state.selectedSkuId;
  const externalProductId = state.externalProductId;
  const clientIsLoggedIn = state.clientIsLoggedIn;
  const skipEventTracking = state.skipEventTracking;

  const ctaLink = clientIsLoggedIn
    ? '/onboarding/style-profile?source=ungated-pdp'
    : '/t/signup?default=true&source=ungated-pdp';

  const onCtaClick = () => {
    trackOnboardingCtaClick(
      selectedSkuId,
      externalProductId,
      clientBusinessLine,
      itemBusinessLine,
      skipEventTracking,
    );
  };

  return (
    <div>
      <CrossSellPromo
        variant="fix"
        image={PROMO_IMAGE}
        cta={{
          destinationPath: ctaLink,
          text: CTA_TEXT,
        }}
        expandedContent={{
          title: 'Ready to explore a shop built just for you?',
          images: [PROMO_IMAGE],
          cta: {
            destinationPath: ctaLink,
            text: CTA_TEXT,
          },
        }}
        onClick={onCtaClick}
      />
    </div>
  );
};

export default StyleQuizAd;
